/*

FILE: lightbox.js
DESCRIPTION: Image lightbox functionality
AUTHOR(S): R.J. LaCount

*/

import Tobii from 'tobii';
import Player from '@vimeo/player';

const initLightboxes = () => {
	const tobii = new Tobii({
		captionsSelector: 'self',
		docClose: false
	});
	let close = document.querySelector('.tobii .tobii__close');

	close.addEventListener( 'click', function() {
		console.log('close/pause video');
		var selection = document.getElementsByTagName('iframe');
		var iframes = Array.prototype.slice.call(selection);

		iframes.forEach(iframe => {
			// May need to find a way to exclude the Recaptca iFrame
			const player = new Player(iframe);
			player.pause();

		});
	});
	
}
  

export { initLightboxes };
